import { signUpFields } from './default-sign-up-fields'

export const signUpConfig = {
  header: 'Create a new account',
  hiddenDefaults: ['email', 'phone_number'],
  signUpFields,
}

export default signUpConfig
